import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    setTimeout(() =>{
      this.embed();
    }, 500)
  }

  embed() {
    var js, tjs = document.getElementsByTagName('script')[0];
    if (document.getElementById('termly-jssdk')) return;
    js = document.createElement('script'); js.id = 'termly-jssdk';
    js.src = "https://app.termly.io/embed-policy.min.js";
    tjs.parentNode.insertBefore(js, tjs);
  }

  ngOnDestroy() {
    document.getElementById('termly-jssdk').remove();
  }

}
